(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["custom-reviews-io-summary"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const $modal = $('#modal');
    const openModal = () => $modal.removeClass('hidden').attr('aria-hidden', 'false');
    const closeModal = () => $modal.addClass('hidden').attr('aria-hidden', 'true');

    $('#open-modal').on('click', openModal);
    $modal.on('click', '[data-modal-close]', closeModal);

    // ESC key for accessibility
    $(document).on('keydown', (e) => {
      if (e.key === 'Escape' && $modal.attr('aria-hidden') === 'false') closeModal();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
